import { RootState } from '@greenkub-fronts/shared/interface';
import { useSelector } from 'react-redux';
import CustomerFooter from '../../../ui/web/commons/customer-footer/customer-footer'

export function CustomerFooterFeature() {

  const { currentTheme } = useSelector((state: RootState) => state.ui)

  return <CustomerFooter currentTheme={currentTheme} />;
}

export default CustomerFooterFeature;
